export const SET_LOCALE_TEXTS = 'APP::SET_LOCALE_MESSAGES';

export function setLocaleTexts(texts) {
    return {
        type: SET_LOCALE_TEXTS,
        texts,
    };
}

export const SET_LOCALE = 'APP::SET_LOCALE';

export function setLocale(locale) {
    return {
        type: SET_LOCALE,
        locale,
    };
}

export const TOGGLE_LANGUAGE_MENU = 'APP::TOGGLE_LANGUAGE_MENU';

export function toggleLanguageMenu() {
    return {
        type: TOGGLE_LANGUAGE_MENU,
    };
}

export const TOGGLE_SIDE_MENU = 'APP::TOGGLE_SIDE_MENU';

export function toggleSideMenu() {
    return {
        type: TOGGLE_SIDE_MENU,
    };
}

export const TOGGLE_IMPRINT_POPUP = 'APP::TOGGLE_IMPRINT_POPUP';

export function toggleImprintPopup() {
    return {
        type: TOGGLE_IMPRINT_POPUP,
    };
}

export const TOGGLE_DATA_PRIVACY_POPUP = 'APP::TOGGLE_DATA_PRIVACY_POPUP';

export function toggleDataPrivacyPopup() {
    return {
        type: TOGGLE_DATA_PRIVACY_POPUP,
    };
}

export const TOGGLE_BROWSER_DETECT_POPUP = 'APP::TOGGLE_BROWSER_DETECT_POPUP';

export function toggleBrowserDetectPopup() {
    return {
        type: TOGGLE_BROWSER_DETECT_POPUP,
    };
}

export const SET_DEALER = 'APP::SET_DEALER';

export function setDealer(dealer) {
    return {
        type: SET_DEALER,
        dealer,
    };
}

export const SET_IS_LOADING = 'APP::SET_IS_LOADING';

export function setIsLoading(isLoading) {
    return {
        type: SET_IS_LOADING,
        isLoading,
    };
}
